// Signed image URLs are credentials. Check every breadcrumb type, including
// console/CSP messages, rather than only network events.
export function containsPrivateImageUrl(value: unknown, seen = new WeakSet<object>()): boolean {
  if (typeof value === "string") {
    return /https?:\/\/[^\s"'<>]*\.blob\.core\.windows\.net(?:[/:?]|$)|[?&]sig=/i.test(value)
  }
  if (!value || typeof value !== "object" || seen.has(value)) return false
  seen.add(value)
  try {
    if (value instanceof Error && containsPrivateImageUrl(`${value.message} ${value.stack}`)) {
      return true
    }
    return Object.values(value).some((entry) => containsPrivateImageUrl(entry, seen))
  } catch {
    // Rollbar disables a throwing filter; discard unreadable data instead.
    return true
  }
}
